import {Storage} from "@/services/Storage";
import axios from "axios";
import router from "@/router";
import Swal from "sweetalert2";
import OneSignal from 'onesignal-vue';
import {Device} from "@/services/Device";
import indexedDB from '@/store/modules/helpers/indexedDB';
import {initOneSignal} from "@/services/GlobalVariables";
import store from "@/store";
import Vue from "vue";


export default {
    name: 'user',
    state: {
        permissions: {},
        selectUserInfo: null,
        role_permissions: [],
        current_user: null,
        current_session: null,
        employeeFine: [],
        allUsers: [],
        userTypes: ['Super_User', 'Developer', 'Technician', 'Sales'],
        attemptedLoginRoute : { name : `user-dashboard` },
        otp: null,
        otpVerified: false,
        deviceId: null,
    },
    getters: {
        getPermissions: (state) => state.permissions,
        getSelectUser: (state) => state.selectUserInfo,
        getRoles: (state) => state.role_permissions,
        getEmployeeFine: (state) => state.employeeFine,
        getCurrentUser: (state) => state.current_user,
        getAllUsers: (state) => state.allUsers,
        getUserTypes: (state) => state.userTypes,
        getAttemptedRoute: (state) => state.attemptedLoginRoute,
        getUserByID: (state) => (id)=> state.allUsers.find(user => user.id === id),
        getOtp: (state) => state.otp,
        isOtpVerified: (state) => state.otpVerified,
        getDeviceId: (state) => state.deviceId,
    },
    mutations: {
        setOtpVerified: (state, verified) => {
            state.otpVerified = verified;
        },
        setOtp: (state, otp)=>{
          state.otp = otp;
        },
        SET_PERMISSIONS(state, permissions) {
            state.permissions = permissions; // Save the entire permissions object
        },
        CLEAR_PERMISSIONS(state) {
            state.permissions = {}; // Clear permissions on logout
        },
        SET_EMPLOYEE_FINE: (state, data) => {
            state.employeeFine = data
        },
        setPermissionRoles: (state, data) => {
            state.role_permissions = data
        },

        setCurrentUser: (state, data) => {
            state.current_user = data;
        },

        setUsers: async (state, data) => {
            if (data) await Storage.setUsers(data)
            else data = await Storage.getAllUsers();
            state.allUsers = data;
        },
        setUserTypes: (state, data) => state.userTypes = data,
        setAttemptedRoute: (state, data) => state.attemptedLoginRoute = data,
        setSessionID:async (state , data) => {
            if (data) await Storage.setSessionID(data)
            else data = await Storage.getSessionID();
            state.current_session = data;
        },
        setUserInfo(state, user) {
            state.selectUserInfo = user; // Update user state
        },
        setDeviceId(state, deviceId) {
            state.deviceId = deviceId;
        }
    },
    actions: {

        initializeAuth(context) {
            const otpVerified = localStorage.getItem('otpVerified') === 'true';
            context.commit('setOtpVerified', otpVerified);
            // Other initialization logic test
        },
        setPermissions({ commit }, permissions) {
            commit("SET_PERMISSIONS", permissions);
        },
        clearPermissions({ commit }) {
            commit("CLEAR_PERMISSIONS");
        },
        updateSetUserInfo({ commit }, user) {
            commit("setUserInfo", user);
        },
        async fetchEmployeeFine( context, userId = null ) {
            try {
                let users = context.getters.getCurrentUser;
                let idToUse = userId || users.id;
                const response = await axios.get(synergy4 + `disciplinaryAction/getEmployeeFine/${idToUse}`);
                context.commit("SET_EMPLOYEE_FINE", response.data); // Commit mutation to update state
                console.log(response.data);
            } catch(error) {
                await errorHandler.tomcatError(error);
            }
        },
        async getAllRoles( context ) {
            try {
                const response = await axios.get(`${synergy4}employee/getAllRoles`);
                context.commit("setPermissionRoles", response.data);
                this.allRoles = response.data;
                console.log(this.allRoles);
            } catch (error) {
                await errorHandler.tomcatError(error);
            }
        },

        getEarlyLeaveRequest: async (context,userID) => {
            return await axios.get(`${synergy4}employee/getEarlyLeaveRequest/${userID}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        triggerResetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${window.synergy4}employee/resetPassword`,
                payload:{
                    email: payload,
                }
            })
        },
        resetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${window.synergy3}employee/processResetPassword`,
                payload,
                method: "post"
            })
        },

        updateUserOnlineStatus:async (context) => {
            let user = await Storage.getCurrentUser();
            let id = user.id;
            return axios.put(ticketApi + `user/updateOnlineStatus/${id}`,{})
        },
        getAllUsers: async (context) => {
            return axios.get(ticketApi + `user/getAll`)
                .then(({data}) => {
                    context.commit('setUsers', data)
                    console.log(data)
                });
        },
         userLogin: async (context, payload) => {
             return axios.post(ticketApi + `user/Login`, payload)
                 .then(({data}) => {
                     context.commit('setCurrentUser', data)
                     return router.push({name: 'OTP'});
                 }).catch(err => errorHandler.tomcatError(err))
         },
        userLogin2: async (context, payload) => {
            return axios.post(ticketApi + `user/Login`, payload)
                .then(({data}) => {
                    return context.commit('setCurrentUser', data);
                }).catch(err => errorHandler.tomcatError(err))
        },

        verifyOtp: async (context, payload) => {
            console.log(payload)
            context.commit('setOtp', payload.otp)
            return axios.post(ticketApi + 'user/verifyOtp', payload)
                .then(async ({data}) => {
                    context.commit(`setSessionID`, data)
                    localStorage.setItem('setSessionID', data);
                    context.commit('setOtpVerified', true); // Set OTP as verified
                    localStorage.setItem('otpVerified', 'true');
                    let route = context.getters.getAttemptedRoute || { name: 'user-dashboard' };
                    let routeName = route.name;
                    const resolvedRoute = router.resolve({ name: routeName });
                    let exists = resolvedRoute.route.name === routeName;
                    if (!exists) route = { name: `user-dashboard` };
                    let deviceId = context.state.deviceId;

                    // await axios.post(`${ticketApi}one-signal/register-device`, {
                    //     device_name: "Device",
                    //     userId: context.state.current_user.id,
                    //     deviceId: deviceId
                    // });

                    return router.push(route);
                }).catch(err => errorHandler.tomcatError(err));
        },
        searchTurnoverData: (context, user) => {
            const dateRange = context.getters.getGlobalDateRange;
            let obj = {
                quotedBy: user,
                ...context.getters.getGlobalDateRange
            }//
            return axios.get(synergy4+`api/sales/turnover?quotedBy=${user}&from=${dateRange.from}&to=${dateRange.to}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        searchQuoteTurnoverData: (context, user) => {
            const dateRange = context.getters.getGlobalDateRange;
            let obj = {
                user,
                ...context.getters.getGlobalDateRange
            }
            return axios.get(synergy4+`api/sales/quoteTurnover?user=${user}&from=${dateRange.from}&to=${dateRange.to}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        searchHardwarePercentageData: (context, user) => {
            const dateRange = context.getters.getGlobalDateRange;
            let obj = {
                quotedBy: user,
                ...context.getters.getGlobalDateRange
            }
            return axios.get(synergy4+`api/sales/hardwarePercentage?quotedBy=${user}&from=${dateRange.from}&to=${dateRange.to}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        searchPercentageToTargetData: (context, user) => {
            let obj = {
                quotedBy: user,
                ...context.getters.getGlobalDateRange
            }
            return axios.get(synergy4+`api/sales/percentageToTarget?quotedBy=${user}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        searchPercentageToTargetData2: (context, user) => {
            const dateRange = context.getters.getGlobalDateRange;
            let obj = {
                quotedBy: user,
                ...context.getters.getGlobalDateRange
            }
            return axios.get(synergy4+`api/sales/PeriodPercentageToTarget?quotedBy=${user}&from=${dateRange.from}&to=${dateRange.to}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        searchConversionPercentageData: (context, user) => {
            let dataRange = context.getters.getGlobalDateRange;
            return axios.get(synergy4+`api/sales/conversionPercentage?username=${user}&from=${dataRange.from}&to=${dataRange.to}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        searchCommsionData: (context, user) => {
            let dataRange = context.getters.getGlobalDateRange;
            return axios.get(synergy4+`api/sales/calculate/${user}?from=${dataRange.from}&to=${dataRange.to}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        getAllSalesMeetings2: (context, user) => {
            let dataRange = context.getters.getGlobalDateRange;
            return axios.get(synergy4+`api/sales/attended/count?From=${dataRange.from}&to=${dataRange.to}&userName=${user}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        getAllLateToMeetings2: (context, user) => {
            let dataRange = context.getters.getGlobalDateRange;
            return axios.get(synergy4+`api/sales/late/count?From=${dataRange.from}&to=${dataRange.to}&userName=${user}`)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },

        searchAllQuotes: async (context, payload) => {
            let storeDB = 'burntofi_chrilan';
            let obj = {
                ...context.getters.getGlobalDateRange,
                ...payload,
                // User: !payload.User ? user.Username : payload.User,
            };
            console.log('THIS IS THE OBJECT', obj)
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/searchAllQuotes`, obj)
                .then(({data}) => {
                    console.log("THIS DATA", data);
                    return data;
                })
                .catch((err) => errorHandler.tomcatError(err))
        },
        async getAllInvoices(context, user) {
            let dataRange = context.getters.getGlobalDateRange;
            return axios.get(synergy4 + `api/sales/GetInvoicesByUsername?username=${user}&from=${dataRange.from}&to=${dataRange.to}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        async getMeetingPunctuality(context, form) {
            let dataRange = context.getters.getGlobalDateRange;
            return axios.get(synergy4 + `api/sales/SalesMeetings?startDate=${dataRange.from}&endDate=${dataRange.to}&userName=${form.username}&status=${form.status}&isSuccessful=${form.successful}&isOngoing=${form.ongoing}&hasFollowups=${form.hasFollowUp}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        createUser: (context, payload) => {
            let phoneNumber = payload.phone_number;
            payload.phone_number = `260`+phoneNumber;
            return axios.post(ticketApi + `user`, payload)
                .then(() => context.dispatch('getAllUsers'))
        },

        updateUser: (context, payload) => {
            let ID = payload.id;
            let phoneNumber = payload.phone_number;
            payload.phone_number = `260`+phoneNumber
            return axios.put(ticketApi + `user/${ID}`, payload)
                .then(() => context.dispatch('getAllUsers'))
        },

        getUserByID: (context, id) => {
            return axios.get(ticketApi + `user/${id}`)
                .then(({data}) => data)
        },


        checkAndRegisterDevice: async (context) => {
            const userId = context.state.current_user.id;

            // Step 1: Load or generate device ID
            let deviceId = await indexedDB.getDeviceID();
            // let deviceId = await context.getters.getDeviceId;

            if (!deviceId) {
                deviceId = crypto.randomUUID(); // Generate proper unique ID
                await indexedDB.setDeviceId(deviceId);
                context.commit('setDeviceId', deviceId);
                console.log("Generated new device ID:", deviceId);
            } else {
                context.commit('setDeviceId', deviceId);
                console.log("Loaded existing device ID:", deviceId);
            }

            try {
                // Step 2: Check backend if device is already registered
                const { data } = await axios.get(`${ticketApi}oneSignal/checkDeviceId/${deviceId}`);

                if (data.isDevice === true) {
                    // If already registered
                    await Swal.fire({
                        icon: 'info',
                        title: 'Device Already Registered',
                        text: 'This device has already been registered and is linked to your account.',
                        timer: 2500
                    });
                    return;
                }

                const notificationConsent = await Swal.fire({
                    title: 'Receive Notifications?',
                    text: "Would you like to receive notifications on this device?",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, I want',
                    cancelButtonText: "No, thanks"
                });

                if (!notificationConsent.isConfirmed) {
                    console.log("User declined notification registration.");
                    return; // user clicked "No"
                }

                // Step 3: Prompt for device name
                const { value: deviceName } = await Swal.fire({
                    title: 'Register your device',
                    input: 'text',
                    inputLabel: 'Device Name',
                    inputPlaceholder: 'Enter a name for this device',
                    inputValidator: (value) => {
                        if (!value) {
                            return 'You need to enter a device name!';
                        }
                        return null;
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Register'
                });

                if (!deviceName) {
                    console.warn("Device registration cancelled");
                    return;
                }

                // Step 4: Register device with backend
                await axios.post(`${ticketApi}oneSignal/registerDevice`, {
                    device_name: deviceName,
                    userId: context.state.current_user.id,
                    deviceId: deviceId
                });

                // Step 5: Trigger OneSignal subscription
                try {
                    // Get the OneSignal instance
                    window.OneSignalDeferred = window.OneSignalDeferred || [];
                    window.OneSignalDeferred.push(async function(OneSignal) {
                        // Request permission using the native browser prompt
                        const permission = await Notification.requestPermission();

                        if (permission === 'granted') {
                            // Login to OneSignal with the device ID
                            await OneSignal.login(deviceId.toString());
                            console.log("OneSignal subscription successful");
                        } else {
                            console.warn("Notification permission denied by user");
                        }
                    });
                } catch (error) {
                    console.error("Error subscribing to OneSignal:", error);
                }

                console.log("Device registered successfully.");

                await Swal.fire({
                    icon: 'success',
                    title: 'Device Registered!',
                    text: 'Your device has been successfully registered.',
                    timer: 2000
                });
                window.location.reload();
            } catch (err) {
                await errorHandler.tomcatError(err);
            }
        }
    }
}

//         import {Storage} from "@/services/Storage";
//         import axios from "axios";
//         import router from "@/router";
//         import Swal from "sweetalert2";
//         import OneSignal from 'onesignal-vue';
//         import {Device} from "@/services/Device";
//         import {initOneSignal} from "@/services/GlobalVariables";
//         import store from "@/store";
//         import Vue from "vue";
//
//         export default {
//             name: 'user',
//             state: {
//                 permissions: {},
//                 selectUserInfo: null,
//                 role_permissions: [],
//                 current_user: null,
//                 current_session: null,
//                 employeeFine: [],
//                 allUsers: [],
//                 userTypes: ['Super_User', 'Developer', 'Technician', 'Sales'],
//                 attemptedLoginRoute : { name : `user-dashboard` },
//                 otp: null,
//                 otpVerified: false,
//                 deviceId: null,
//             },
//             getters: {
//                 getPermissions: (state) => state.permissions,
//                 getSelectUser: (state) => state.selectUserInfo,
//                 getRoles: (state) => state.role_permissions,
//                 getEmployeeFine: (state) => state.employeeFine,
//                 getCurrentUser: (state) => state.current_user,
//                 getAllUsers: (state) => state.allUsers,
//                 getUserTypes: (state) => state.userTypes,
//                 getAttemptedRoute: (state) => state.attemptedLoginRoute,
//                 getUserByID: (state) => (id)=> state.allUsers.find(user => user.id === id),
//                 getOtp: (state) => state.otp,
//                 isOtpVerified: (state) => state.otpVerified,
//                 getDeviceId: (state) => state.deviceId,
//             },
//             mutations: {
//                 setOtpVerified: (state, verified) => {
//                     state.otpVerified = verified;
//                 },
//                 setOtp: (state, otp)=>{
//                     state.otp = otp;
//                 },
//                 SET_PERMISSIONS(state, permissions) {
//                     state.permissions = permissions; // Save the entire permissions object
//                 },
//                 CLEAR_PERMISSIONS(state) {
//                     state.permissions = {}; // Clear permissions on logout
//                 },
//                 SET_EMPLOYEE_FINE: (state, data) => {
//                     state.employeeFine = data
//                 },
//                 setPermissionRoles: (state, data) => {
//                     state.role_permissions = data
//                 },
//
//                 setCurrentUser: async (state, data) => {
//                     state.current_user = data
//                 },
//
//                 setUsers: async (state, data) => {
//                     if (data) await Storage.setUsers(data)
//                     else data = await Storage.getAllUsers();
//                     state.allUsers = data;
//                 },
//                 setUserTypes: (state, data) => state.userTypes = data,
//                 setAttemptedRoute: (state, data) => state.attemptedLoginRoute = data,
//                 setSessionID:async (state , data) => {
//                     if (data) await Storage.setSessionID(data)
//                     else data = await Storage.getSessionID();
//                     state.current_session = data;
//                 },
//                 setUserInfo(state, user) {
//                     state.selectUserInfo = user; // Update user state
//                 },
//                 setDeviceId(state, deviceId) {
//                     state.deviceId = deviceId;
//                 }
//             },
//             actions: {
//
//                 // async oneSignalSubscription(context) {
//                 //     try {
//                 //         // Initialize OneSignal with your app ID
//                 //         await window.OneSignal.init({appId: 'f3deb813-cfe8-4acd-9773-8d72d96e14bb'});
//                 //
//                 //         // Set up the subscription change listener
//                 //         window.OneSignal.User.PushSubscription.addEventListener("change", async (event) => {
//                 //             try {
//                 //                 if (event.current.token) {
//                 //                     await window.OneSignal.login(context.state.deviceId);
//                 //                 }
//                 //             } catch (error) {
//                 //                 console.error('Error in pushSubscriptionChangeListener:', error);
//                 //             }
//                 //         });
//                 //     } catch (error) {
//                 //         console.error('Error initializing OneSignal:', error);
//                 //     }
//                 // },
//
//                 initializeAuth(context) {
//                     const otpVerified = localStorage.getItem('otpVerified') === 'true';
//                     context.commit('setOtpVerified', otpVerified);
//                     // Other initialization logic test
//                 },
//                 setPermissions({ commit }, permissions) {
//                     commit("SET_PERMISSIONS", permissions);
//                 },
//                 clearPermissions({ commit }) {
//                     commit("CLEAR_PERMISSIONS");
//                 },
//                 updateSetUserInfo({ commit }, user) {
//                     commit("setUserInfo", user);
//                 },
//                 async fetchEmployeeFine( context, userId = null ) {
//                     try {
//                         let users = context.getters.getCurrentUser;
//                         let idToUse = userId || users.id;
//                         const response = await axios.get(synergy4 + `disciplinaryAction/getEmployeeFine/${idToUse}`);
//                         context.commit("SET_EMPLOYEE_FINE", response.data); // Commit mutation to update state
//                         console.log(response.data);
//                     } catch(error) {
//                         await errorHandler.tomcatError(error);
//                     }
//                 },
//                 async getAllRoles( context ) {
//                     try {
//                         const response = await axios.get(`${synergy4}employee/getAllRoles`);
//                         context.commit("setPermissionRoles", response.data);
//                         this.allRoles = response.data;
//                         console.log(this.allRoles);
//                     } catch (error) {
//                         await errorHandler.tomcatError(error);
//                     }
//                 },
//
//                 getEarlyLeaveRequest: async (context,userID) => {
//                     return await axios.get(`${synergy4}employee/getEarlyLeaveRequest/${userID}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 triggerResetPassword: (context,payload) => {
//                     return context.dispatch(`sendRequest`,{
//                         url : `${window.synergy4}employee/resetPassword`,
//                         payload:{
//                             email: payload,
//                         }
//                     })
//                 },
//                 resetPassword: (context,payload) => {
//                     return context.dispatch(`sendRequest`,{
//                         url : `${window.synergy3}employee/processResetPassword`,
//                         payload,
//                         method: "post"
//                     })
//                 },
//
//                 updateUserOnlineStatus:async (context) => {
//                     let user = await Storage.getCurrentUser();
//                     let id = user.id;
//                     return axios.put(ticketApi + `user/updateOnlineStatus/${id}`,{})
//                 },
//                 getAllUsers: async (context) => {
//                     return axios.get(ticketApi + `user/getAll`)
//                         .then(({data}) => {
//                             context.commit('setUsers', data)
//                             console.log(data)
//                         });
//                 },
//                 userLogin: async (context, payload) => {
//                     return axios.post(ticketApi + `user/Login`, payload)
//                         .then(({data}) => {
//                             context.commit('setCurrentUser', data)
//                             return router.push({name: 'OTP'});
//                         }).catch(err => errorHandler.tomcatError(err))
//                 },
//                 userLogin2: async (context, payload) => {
//                     return axios.post(ticketApi + `user/Login`, payload)
//                         .then(({data}) => {
//                             return context.commit('setCurrentUser', data);
//                         }).catch(err => errorHandler.tomcatError(err))
//                 },
//
//                 verifyOtp: async (context, payload) => {
//                     console.log(payload)
//                     context.commit('setOtp', payload.otp)
//                     return axios.post(ticketApi + 'user/verifyOtp', payload)
//                         .then(async ({data}) => {
//                             context.commit(`setSessionID`, data)
//                             localStorage.setItem('setSessionID', data);
//                             context.commit('setOtpVerified', true); // Set OTP as verified
//                             localStorage.setItem('otpVerified', 'true');
//                             let route = context.getters.getAttemptedRoute || { name: 'user-dashboard' };
//                             let routeName = route.name;
//                             const resolvedRoute = router.resolve({ name: routeName });
//                             let exists = resolvedRoute.route.name === routeName;
//                             if (!exists) route = { name: `user-dashboard` };
//                             let deviceId = context.state.deviceId;
//                             if (!deviceId) {
//                                 deviceId = generateUUID();
//                                 context.commit('setDeviceId', deviceId);
//                                 console.log("DEVICE ID ::" , deviceId);
//
//                                 const result = await Swal.fire({
//                                     title: "Receive Notifications",
//                                     icon: "info",
//                                     text: `Do you want to receive notifications on this device? `,
//                                     showCancelButton: true,
//                                     confirmButtonText: "Yes",
//                                     cancelButtonText: "No",
//                                 });
//
//                                 if (result.isConfirmed) {
//                                     // Register device with backends
//                                     await axios.post(`${ticketApi}register-device`, {
//                                         device_name: "Device",
//                                         userId: context.state.current_user.id,
//                                         deviceId: deviceId
//                                     });
//                                     try {
//                                         const pushSubscriptionChangeListener = async (event) => {
//                                             try {
//                                                 if (event.current.token) {
//                                                     await Vue.prototype.$OneSignal.login(context.state.deviceId);
//                                                     console.log('Successfully logged in to OneSignal with deviceId:');
//                                                 }
//                                             } catch (error) {
//                                                 console.error('Error in pushSubscriptionChangeListener:', error);
//                                             }
//                                         };
//                                         Vue.prototype.$OneSignal.User.PushSubscription.addEventListener(
//                                             "change",
//                                             pushSubscriptionChangeListener
//                                         );
//                                     } catch (error) {
//                                         console.error('Error logging in to OneSignal:', error);
//                                     }
//                                 }
//                             }
//                             return router.push(route);
//                         }).catch(err => errorHandler.tomcatError(err));
//                 },
//                 searchTurnoverData: (context, user) => {
//                     const dateRange = context.getters.getGlobalDateRange;
//                     let obj = {
//                         quotedBy: user,
//                         ...context.getters.getGlobalDateRange
//                     }//
//                     return axios.get(synergy4+`api/sales/turnover?quotedBy=${user}&from=${dateRange.from}&to=${dateRange.to}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 searchQuoteTurnoverData: (context, user) => {
//                     const dateRange = context.getters.getGlobalDateRange;
//                     let obj = {
//                         user,
//                         ...context.getters.getGlobalDateRange
//                     }
//                     return axios.get(synergy4+`api/sales/quoteTurnover?user=${user}&from=${dateRange.from}&to=${dateRange.to}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 searchHardwarePercentageData: (context, user) => {
//                     const dateRange = context.getters.getGlobalDateRange;
//                     let obj = {
//                         quotedBy: user,
//                         ...context.getters.getGlobalDateRange
//                     }
//                     return axios.get(synergy4+`api/sales/hardwarePercentage?quotedBy=${user}&from=${dateRange.from}&to=${dateRange.to}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 searchPercentageToTargetData: (context, user) => {
//                     let obj = {
//                         quotedBy: user,
//                         ...context.getters.getGlobalDateRange
//                     }
//                     return axios.get(synergy4+`api/sales/percentageToTarget?quotedBy=${user}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 searchPercentageToTargetData2: (context, user) => {
//                     const dateRange = context.getters.getGlobalDateRange;
//                     let obj = {
//                         quotedBy: user,
//                         ...context.getters.getGlobalDateRange
//                     }
//                     return axios.get(synergy4+`api/sales/PeriodPercentageToTarget?quotedBy=${user}&from=${dateRange.from}&to=${dateRange.to}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 searchConversionPercentageData: (context, user) => {
//                     let dataRange = context.getters.getGlobalDateRange;
//                     return axios.get(synergy4+`api/sales/conversionPercentage?username=${user}&from=${dataRange.from}&to=${dataRange.to}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 searchCommsionData: (context, user) => {
//                     let dataRange = context.getters.getGlobalDateRange;
//                     return axios.get(synergy4+`api/sales/calculate/${user}?from=${dataRange.from}&to=${dataRange.to}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 getAllSalesMeetings2: (context, user) => {
//                     let dataRange = context.getters.getGlobalDateRange;
//                     return axios.get(synergy4+`api/sales/attended/count?From=${dataRange.from}&to=${dataRange.to}&userName=${user}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//                 getAllLateToMeetings2: (context, user) => {
//                     let dataRange = context.getters.getGlobalDateRange;
//                     return axios.get(synergy4+`api/sales/late/count?From=${dataRange.from}&to=${dataRange.to}&userName=${user}`)
//                         .then(({data}) => data)
//                         .catch(err => errorHandler.tomcatError(err))
//                 },
//
//                 searchAllQuotes: async (context, payload) => {
//                     let storeDB = 'burntofi_chrilan';
//                     let obj = {
//                         ...context.getters.getGlobalDateRange,
//                         ...payload,
//                         // User: !payload.User ? user.Username : payload.User,
//                     };
//                     console.log('THIS IS THE OBJECT', obj)
//                     return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/searchAllQuotes`, obj)
//                         .then(({data}) => {
//                             console.log("THIS DATA", data);
//                             return data;
//                         })
//                         .catch((err) => errorHandler.tomcatError(err))
//                 },
//                 async getAllInvoices(context, user) {
//                     let dataRange = context.getters.getGlobalDateRange;
//                     return axios.get(synergy4 + `api/sales/GetInvoicesByUsername?username=${user}&from=${dataRange.from}&to=${dataRange.to}`)
//                         .then(({data}) => data)
//                         .catch((err) => errorHandler.tomcatError(err))
//                 },
//                 async getMeetingPunctuality(context, user) {
//                     let dataRange = context.getters.getGlobalDateRange;
//                     return axios.get(synergy4 + `api/sales/SalesMeetings?startDate=${dataRange.from}&endDate=${dataRange.to}&userName=${user}`)
//                         .then(({data}) => data)
//                         .catch((err) => errorHandler.tomcatError(err))
//                 },
//
//         createUser: (context, payload) => {
//             let phoneNumber = payload.phone_number;
//             payload.phone_number = `260`+phoneNumber;
//             return axios.post(ticketApi + `user`, payload)
//                 .then(() => context.dispatch('getAllUsers'))
//         },
//
//         updateUser: (context, payload) => {
//             let ID = payload.id;
//             let phoneNumber = payload.phone_number;
//             payload.phone_number = `260`+phoneNumber
//             return axios.put(ticketApi + `user/${ID}`, payload)
//                 .then(() => context.dispatch('getAllUsers'))
//         },
//
//         getUserByID: (context, id) => {
//             return axios.get(ticketApi + `user/${id}`)
//                 .then(({data}) => data)
//         },
//     }
// }
